import { Paystub } from './paystub';
import { DRIVER } from '../drivers/mock-driver';
import { JOB } from '../jobs/mock-job';
import { CONDENSEDTRIP } from '../trips/mock-condensed-trip';
import { CONDENSEDPUNCHCARD } from '../punch-cards/mock-condensed-punch-card';
import { ORGANIZATION } from '../organizations/mock-organization';

export let PAYSTUB: Paystub = <Paystub> {
  id: '00000000-0000-0000-0000-000000000001',
  number: '1234',
  amount: '1234.56',
  expenseAmount: '1234.56',
  surchargeAmount: '100.00',
  tripsAmount: '0.0',
  tripsExpenseAmount: '0.0',
  punchcardsAmount: '0.0',
  punchcardsExpenseAmount: '0.0',
  subtotal: '123.00',
  ownerOrganization: ORGANIZATION,
  customerOrganization: ORGANIZATION,
  driver: DRIVER,
  job: JOB,
  sendable: true,
  sent: false,
  draft: true,
  sentTime: '2017-05-03T08:00:00Z',
  sentBy: '',
  sentTrips: [CONDENSEDTRIP, CONDENSEDTRIP],
  sentPunchCards: [CONDENSEDPUNCHCARD, CONDENSEDPUNCHCARD],
  billFromContactEmail: 'invoice\@goruckit.com',
  billFromCcEmails: 'diego\@goruckit.com, adriana\@goruckit.me',
  billFromAddress: 'Ruckit',
  billToContactEmail: 'johndoe\@brbrokergroup.biz',
  billToCcEmails: '',
  billToAddress: 'B\&R Broker Group LLC',
  createdAt: '2017-05-03T08:00:00Z',
  paystubUrl: '',
  startDate: '2017-04-03T08:00:00Z',
  endDate: '2017-05-03T08:00:00Z',
  remittanceInfo: 'Remittance Info',
  earliestBillableItemTime: '',
  latestBillableItemTime: '',
  paystubPeriod: 'April 3, 2017 - May 3, 2017',
  title: 'Paystub Draft',
  administrativeStatus: 'draft',
  displayableStatus: false,
  shortTitle: 'Paystub Draft ',
  pdf: '',
  html: '',
  paymentType: 'Check',
  url: null,
  filterOptions: null
};
